module.exports = __webpack_public_path__ + "assets/img/组 158@2x.4384d435.png";